var EVENT_UPDATE = 'product_wishlist_update';
var STORAGE_KEY = 'product-wishlist';
var storage = window.localStorage;

function addProduct(product) {
  var products = getProducts();

  if (!products.includes(product)) {
    products.push(product);
  }

  saveProducts(products);
}

function removeProduct(product) {
  var products = getProducts();
  var index = products.indexOf(product);

  if (index !== -1) {
    products.splice(index, 1);
  }

  saveProducts(products);
}

function clearProducts() {
  storage.removeItem(STORAGE_KEY);
  document.dispatchEvent(new CustomEvent(EVENT_UPDATE));
}

function hasProduct(product) {
  return getProducts().includes(product);
}

function saveProducts(products) {
  storage.setItem(STORAGE_KEY, products.join(','));
  document.dispatchEvent(new CustomEvent(EVENT_UPDATE));
}

function getProducts() {
  var products = storage.getItem(STORAGE_KEY);

  if (products) {
    products = products.split(',');
  } else {
    products = [];
  }

  return products;
}

function loadProducts(el) {
  el.classList.add('loading');
  fetch("".concat(el.dataset.productWishlistProducts, "?ids=").concat(getProducts().join(',')), {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function (r) {
    return r.text();
  }).then(function (buffer) {
    el.classList.remove('loading');
    el.innerHTML = buffer;
    initElements(el);
  });
}

function initElements() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  parent = parent || document; // Init wishlist product list

  parent.querySelectorAll('[data-product-wishlist-products]').forEach(function (el) {
    loadProducts(el);
    document.addEventListener(EVENT_UPDATE, function () {
      return loadProducts(el);
    });
    document.addEventListener('ajax-form-loaded', function (e) {
      var form = e.detail.form;

      if (form.classList.contains('form-confirmation')) {
        clearProducts();
      } else {
        initElements(form);
      }
    });
  }); // Init wishlist counters

  parent.querySelectorAll('[data-product-wishlist-counter]').forEach(function (el) {
    var update = function update() {
      return el.textContent = getProducts().length;
    };

    document.addEventListener(EVENT_UPDATE, function () {
      return update();
    });
    update();
  }); // Init wishlist "add" buttons

  parent.querySelectorAll('[data-product-wishlist-add]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      addProduct(el.dataset.productWishlistAdd);
    });
  }); // Init wishlist "remove" buttons

  parent.querySelectorAll('[data-product-wishlist-remove]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      removeProduct(el.dataset.productWishlistRemove);
    });
  }); // Init wishlist "toggle" buttons

  parent.querySelectorAll('[data-product-wishlist-toggle]').forEach(function (el) {
    var product = el.dataset.productWishlistToggle;

    var updateButtonState = function updateButtonState() {
      var isInWishlist = hasProduct(product);
      el.textContent = isInWishlist ? el.dataset.productWishlistToggleRemove : el.dataset.productWishlistToggleAdd;
      el.classList.toggle('is-in-wishlist', isInWishlist);
    };

    updateButtonState();
    el.addEventListener('click', function (e) {
      e.preventDefault();

      if (hasProduct(product)) {
        removeProduct(product);
        updateButtonState();
      } else {
        addProduct(product);
        updateButtonState();
      }
    });
  });
}

export default initElements;